export const ERRORS = {
    auth: {
        userNotFound: {
            code: "auth/user-not-found",
            message: "Email not found. Please, type a valid email."
        },
        passwordIncorrect: {
            code: "auth/wrong-password",
            message: "Wrong password. Please, type a valid password or reset it."
        }
    }
}